import _extends from "@babel/runtime/helpers/extends";
import * as React from "react";

function Phone(props) {
  return React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    d: "M6 20h12V2H6v18zm6 3a1 1 0 110-2 1 1 0 010 2zm6-23H6a2 2 0 00-2 2v20a2 2 0 002 2h12a2 2 0 002-2V2a2 2 0 00-2-2z",
    clipRule: "evenodd"
  }));
}

export { Phone };
//# sourceMappingURL=Phone.js.map